// extracted by mini-css-extract-plugin
export default {"main":"ZeroRestricted-module__main___i7rHf"};